module.exports = __webpack_public_path__ + "static/media/arrow-right--blue.3f6e0425.svg";